(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbIndexTypesService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', IndexTypesService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbIndexTypesService
	 * 
	 * @description
	 * Exposes methods for retrieving content types that belong to a content
	 * type group.
	 */
	function IndexTypesService($http, $q, gettextCatalog, pxUriPathService) {
		
		return {
			/**
			 * @ngdoc method
			 * @name smbIndexTypesService.getIndexTypes
			 * @methodOf smb-app.smbIndexTypesService
			 * @kind function
			 * 
			 * @description
			 * Gets all content types the belong to a content type group
			 * 
			 * @param {Number} typeId Id of the content type group
			 * 
			 * @returns {Deferred} A promise that will resolve to a collection of content types
			 */
			getIndexTypes: getIndexTypes,

			getDocumentTypeGroupIndexTypes: getDocumentTypeGroupIndexTypes,

			setIndexTypes: setIndexTypes,

			getDocumentIndexes: getDocumentIndexes
		};

		function getIndexTypes(typeId) {
			if (!typeId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
			}

			var uri = pxUriPathService.resolvePath('/f/' + typeId + '/tagtypes');
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}

		function getDocumentTypeGroupIndexTypes(groupId) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}

		function setIndexTypes(indexes, documentId) {
			var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/systemtags');
			return $http.put(uri, indexes)
				.then(function (response) {
					return response;
				});
		}

		function getDocumentIndexes(documentId) {
			var uri = pxUriPathService.resolvePath('/documents/' + documentId + '/tags');
			return $http.get(uri)
				.then(function(res) { return res.data; });
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/indexTypesService.js
// module id = 156
// module chunks = 1